import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeUntil';
import {AbstractEpics} from '../redux/AbstractEpics';
import {epicErrorHandler} from '../rx-utils';

/**
 * Exported for unit testing
 */
export class ReduxRequestModalEpics extends AbstractEpics {
  /**
   * @param {ReduxRequest} reduxRequest
   * @param {ReactReduxModal} reduxModal
   * @param {ReduxRequestModalOptions} options
   */
  constructor(reduxRequest, reduxModal, options) {
    super(options);

    /** @type {ReduxRequest} */
    this.reduxRequest = reduxRequest;
    /** @type {ReduxRequestActions} */
    this.requestActions = reduxRequest.actions;
    /** @type {ReactReduxModalActions} */
    this.modalActions = reduxModal.actions;
    /** @param {ReduxRequestModalOptions} */
    this.options = options;

    this.hideOnResult = this.hideOnResult.bind(this);

    this.onRequestComplete = this.onRequestComplete.bind(this);
    this.addEpic(this.onRequestComplete);

    this.addEpics(reduxRequest.epics.epics);
    this.addEpics(reduxModal.epics.epics);
  }

  onRequestComplete(action$) {
    const resetActions = this.getResetActions();

    return action$.ofType(this.requestActions.requestSuccess.TYPE, this.requestActions.requestError.TYPE)
      .filter(this.hideOnResult)
      .switchMap(() =>
        action$.ofType(...resetActions)
          .take(1)
          .mapTo(this.modalActions.hideModal())
          .takeUntil(action$.ofType(this.modalActions.hideModal.TYPE))
      )
      .catch(epicErrorHandler(this.logger, 'ReduxRequestModalEpics.onRequestComplete'));
  }

  hideOnResult(action) {
    return action.type === this.requestActions.requestSuccess.TYPE || (
      this.options.hideOnError && action.type === this.requestActions.requestError.TYPE
    );
  }

  getResetActions() {
    return [
      this.requestActions.resetRequest,
      ...(this.reduxRequest.options.resetActions || []),
    ].map(action => action.TYPE);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-request-modal/epics.js